module.exports = __webpack_public_path__ + "static/img/innovative-icon.22f6633a.png";